import React, { useEffect } from 'react';
import styles from './Messages.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import { changeMessagesPage, getMessages } from '../../store/actions/messages';
import MessageTableLoader from '../shared/ContentLoader/MessageTableLoader';
import Title from '../shared/Title/Title';
import Table from './Table/Table';
import Filter from './Filter/Filter';
import { getTranslation } from '../../utils/translation';
import useOnScreen from '../../hooks/useOnScreen';

const Messages = () => {
    const dispatch = useDispatch();

    const {
        currentPage,
        isFetching,
        isPaginating,
        hasMore,
        selectedStatus,
        pageSize,
    } = useSelector(state => state.messages);

    useEffect(() => {
        dispatch(getMessages({ index: currentPage - 1, status: selectedStatus, size: pageSize }));
    }, []);

    const { ref, isIntersecting: isVisible } = useOnScreen();

    useEffect(() => {
        if (!isFetching && !isPaginating && isVisible && hasMore) {
            fetchMoreMessages();
        }
    }, [isVisible]);

    // Skeleton loader for messagesTable
    const renderTableSkeleton = () => {
        return Array(10)
            .fill('')
            .map((row, index) => (
                <MessageTableLoader key={index} style={{ opacity: Number(2 / index).toFixed(1) }} />
            ));
    };

    const fetchMoreMessages = () => {
        dispatch(changeMessagesPage(currentPage + 1));
        dispatch(getMessages({ index: currentPage, status: selectedStatus, size: pageSize }));
    };

    return (
        <div className={styles.messages}>
            <Title title={getTranslation('title.messages')} />
            <Filter />
            <div className={styles.content}>
                {isFetching ? renderTableSkeleton() : <Table />}
                <button className={'v-hidden h-0'} ref={ref}>
                    Load More
                </button>
            </div>
        </div>
    );
};

export default Messages;
